@if (!listOffers() && !isErrorRequest()) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    <p class="spinner-message">This may take a moment, please wait...</p>
  </div>
} @else if (isErrorRequest()) {
  <app-error-component [errorMessage]="errorMessage()" />
} @else {
  <div class="letter-container">
    <div class="name-box">Hi {{ clientName() }},</div>

    <div class="links-box">
      <div class="text-box bold-p">What’s Next</div>
      <div>Follow these simple steps to reserve your accommodation:</div>
      <ol>
        <li>
          <span class="bold-p">Explore your options</span> - Review each
          property we’ve selected for you.
        </li>
        <li>
          <span class="bold-p">Pick your favourite </span> - Choose the one that
          best matches your needs.
        </li>
        <li>
          <span class="bold-p">Check the details</span> - Make sure the
          location, amenities, and features fit your requirements (once booked,
          changes or cancellations may not be possible).
        </li>
        <li>
          <span class="bold-p">Reserve your choice</span> - Click Reserve on
          your preferred property and we’ll handle the booking for you.
        </li>
      </ol>

      <div class="card-list">
        @for (offerItem of listOffers(); track offerItem.id) {
          <app-offer-card
            [offerItem]="offerItem"
            (goToOffer)="goToOffer.emit($event)" />
        }
      </div>
    </div>

    <div class="text-box">
      <p class="middle-p">
        The sooner you come back to us the better the chances are that those
        options remain available. Once we have booked the accommodation, we will
        share the confirmation with you by email, as well as any specific
        details in relation to the property.
      </p>
      <p class="middle-p">
        As we are booking the property on behalf of your insurer, there is a
        disclaimer in relation to the booking. It is important that you read
        this to understand your responsibilities. If the chosen property is no
        longer available, we will contact you with alternate options.
      </p>

      <div class="text-box center-p">
        <div class="middle-p">
          Please feel free to call us on
          <a class="bold-p link" href="tel:1800 994 412">1800 994 412</a>
          if you have any questions about your booking.
        </div>
      </div>

      <div class="text-box small-p"><b>Disclaimer</b></div>
      <p class="small-p">
        Your insurer agrees to cover the cost of the agreed-upon accommodation,
        which includes WiFi and one car space (if available). Any additional
        costs you incur will not be covered. The accommodation provider may
        request a credit or debit card on arrival for incidentals. If your claim
        is withdrawn, denied, or found to be fraudulent, you may be liable for
        the cost of the accommodation. By proceeding, you accept these terms.
      </p>
    </div>

    <div class="accomodation-box"></div>
  </div>
}
